import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { GeckoField, GECKO_CONSTS } from 'ui';
import CONSTANTS from 'chat-constants';
import './index.scss';
import { channelsForUsersTeams } from '../../services/team-filtering';

export class ChannelOption extends Component {
  render() {
    let channelProperties =
      this.props.channel && CONSTANTS.CHANNEL.DETAILS[this.props.channel.type];
    if (!channelProperties) {
      channelProperties = {
        ICON: 'fas fa-question-circle',
        BRAND_COLOUR: 'grey',
      };
    }
    const iconStyle = { color: channelProperties.BRAND_COLOUR };
    return (
      <div className="ChannelSelect-ChannelOption">
        <i className={`${channelProperties.ICON}`} style={iconStyle}></i>
        {this.props.channel.name}
      </div>
    );
  }
}

export class ChannelValue extends Component {
  render() {
    return (
      <div className="ChannelSelect-ChannelValue">
        {this.props.channel.name}
      </div>
    );
  }
}

export class ChannelSelect extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  renderOption(option) {
    if (option.channel) {
      return <ChannelOption {...option} />;
    }
    return option.label;
  }

  renderValue(option) {
    if (option.channel) {
      return <ChannelOption {...option} />;
    }
    return option.label;
  }

  field = {
    key: 'value',
    type: this.props.multi
      ? GECKO_CONSTS.FIELD_TYPE_SELECT_MULTI
      : GECKO_CONSTS.FIELD_TYPE_SELECT,
    options: this.props.includeDeletedChannels
      ? [
          {
            label: 'Active',
            options: this.props.channels
              .filter((channel) => channel.deletedAt == null)
              .map((channel) => {
                return {
                  channel: channel,
                  label: channel.name,
                  value: channel.id,
                };
              }),
          },
          {
            label: 'Deleted',
            options: this.props.channels
              .filter((channel) => channel.deletedAt != null)
              .map((channel) => {
                return {
                  channel: channel,
                  label: channel.name,
                  value: channel.id,
                };
              }),
          },
        ]
      : this.props.channels.map((channel) => {
          return {
            channel: channel,
            label: channel.name,
            value: channel.id,
          };
        }),
    optionRenderer: this.renderOption.bind(this),
    valueRenderer: this.renderValue.bind(this),
    placeholder: this.props.placeholder,
  };

  handleChange(_key, value) {
    this.props.onChange(value);
  }

  render() {
    const values = { value: this.props.value };
    return (
      <div className="ChannelSelect">
        <GeckoField
          field={this.field}
          values={values}
          handler={this.handleChange.bind(this)}
        />
      </div>
    );
  }
}

const mapStateToProps = (state, props) => {
  const channels = props.filterChannelsByTeam
    ? channelsForUsersTeams(state.channels)
    : state.channels;

  return {
    channels: channels
      .filter((channel) => {
        if (!props.includeDeletedChannels && channel.deletedAt) {
          return false;
        }
        if (props.allowedChannelTypes) {
          return props.allowedChannelTypes.includes(channel.type);
        }
        if (!CONSTANTS.CHANNEL.PICKABLE_TYPES.includes(channel.type)) {
          return false;
        }
        const ignoredChannels = CONSTANTS.CHANNEL.UNPICKABLE_TYPES.concat(
          props.ignoredChannels || []
        );
        return !ignoredChannels.includes(channel.type);
      })
      .sort((channel1, channel2) => channel1.type > channel2.type),
  };
};

ChannelSelect.propTypes = {
  includeDeletedChannels: PropTypes.bool,
  filterChannelsByTeam: PropTypes.bool,
  multi: PropTypes.bool,
  ignoredChannels: PropTypes.arrayOf(PropTypes.string),
  allowedChannelTypes: PropTypes.arrayOf(PropTypes.string),
  placeholder: PropTypes.string,
  onChange: PropTypes.func,
};

ChannelSelect.defaultProps = {
  includeDeletedChannels: false,
  filterChannelsByTeam: false,
  multi: false,
  ignoredChannels: [],
  allowedChannelTypes: [],
  placeholder: null,
  onChange: () => {},
};

export default connect(mapStateToProps)(ChannelSelect);
